<p-dialog
    header="Cancel pre-auth"
    [visible]="!!(viewModel$ | async)?.target"
    [modal]="true"
    [draggable]="false"
    [closable]="!(viewModel$ | async)?.target?.cancelling"
    [closeOnEscape]="!(viewModel$ | async)?.target?.cancelling"
    [dismissableMask]="!(viewModel$ | async)?.target?.cancelling"
    [breakpoints]="{ '48rem': '95vw' }"
    [style]="{ width: '28rem', maxWidth: '95vw' }"
    (visibleChange)="!$event && store.dispatch(actions.cancelPreauthDismissed())"
>
    <ng-container *ngIf="viewModel$ | async as viewModel">
        <ng-container *ngIf="viewModel.target as target">
            <p class="p-mt-0">
                Cancel the <strong>{{ viewModel.amount | currency }}</strong> pre-auth
                on this job? The hold will be released and the customer's available
                balance will be restored.
            </p>
            <p class="p-text-secondary p-mb-0" *ngIf="viewModel.terminal">
                Authorization held on terminal {{ viewModel.terminal }}.
            </p>
        </ng-container>
    </ng-container>
    <ng-template pTemplate="footer">
        <div *ngIf="viewModel$ | async as viewModel">
            <p-button
                label="Keep pre-auth"
                severity="secondary"
                [text]="true"
                [disabled]="viewModel.target?.cancelling"
                (onClick)="store.dispatch(actions.cancelPreauthDismissed())"
            ></p-button>
            <p-button
                label="Cancel pre-auth"
                severity="danger"
                [loading]="viewModel.target?.cancelling"
                [disabled]="viewModel.target?.cancelling"
                (onClick)="store.dispatch(actions.cancelPreauthConfirmed())"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
